export default __webpack_public_path__ + "static/media/close_popup.8de247a1.svg";